import React from "react";
import { ActivityComparisonMenu } from "./container-activity-menus";

// Label + comparison control as ONE flex unit, rendered inside the
// toolbar's right-side cluster (UX-team pattern note 2026-07-30: the loose
// label/menu siblings scattered across the toolbar on every page that
// gained the picker).
export default function ComparisonPicker({
  id,
  onSelected,
  selection
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: "comp-picker"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dl-label",
    style: {
      margin: 0
    }
  }, "Trend Comparison:"), /*#__PURE__*/React.createElement(ActivityComparisonMenu, {
    id: id,
    onSelected: onSelected,
    selection: selection
  }));
}